import { Link } from 'react-router-dom';
import type { Article } from '@/mocks/articles';

interface ArticleCardProps {
  article: Article;
}

export default function ArticleCard({ article }: ArticleCardProps) {
  const categoryLabel =
    article.category === 'plot-analysis' ? '剧情解析' :
    article.category === 'characters' ? '角色介绍' :
    article.category === 'guides' ? '游戏攻略' :
    article.category === 'merchandise' ? '周边资讯' : '粉丝社区';

  return (
    <Link
      to={`/article/${article.slug}`}
      className="group block bg-background-50 rounded-lg border border-background-200/70 overflow-hidden hover:border-primary-200 transition-all duration-300"
    >
      <div className="relative h-48 overflow-hidden">
        <img
          src={article.imageUrl}
          alt={article.title}
          className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
          loading="lazy"
        />
        <div className="absolute top-3 left-3">
          <span className="px-2.5 py-1 text-xs font-medium rounded-full bg-background-50/90 text-primary-600">
            {categoryLabel}
          </span>
        </div>
      </div>
      <div className="p-4 md:p-5">
        <h3 className="font-heading text-base font-semibold text-foreground-900 group-hover:text-primary-500 transition-colors line-clamp-2 mb-2">
          {article.title}
        </h3>
        <p className="text-sm text-foreground-500 line-clamp-2 mb-3 leading-relaxed">
          {article.excerpt}
        </p>
        <div className="flex items-center justify-between text-xs text-foreground-400">
          <div className="flex items-center gap-3">
            <span className="flex items-center gap-1">
              <i className="ri-calendar-line"></i>
              {article.date}
            </span>
            <span className="flex items-center gap-1">
              <i className="ri-time-line"></i>
              {article.readTime}
            </span>
          </div>
          <span className="text-primary-500 group-hover:translate-x-1 transition-transform flex items-center gap-0.5 whitespace-nowrap">
            阅读更多 <i className="ri-arrow-right-line text-xs"></i>
          </span>
        </div>
      </div>
    </Link>
  );
}